import React from 'react';
import { Section, SectionAlternate } from 'components/organisms';
import {
  HeroSection,
} from '../Solutions/components';


import {
  ondcDetails,
  ondcOnboarding,
  whyItMatters,
  whyMperito,
  finalSteps
} from './data';
import { Benefits, FinalSteps, Process, ReadyToStart, TransformBusiness, TrustedPartner, WhyItMatters, WhyMperito } from './components';
import ondcBenefits from './data/ondcBenefits';
import VideoSection from './components/VideoSection';


const ONDC = (props) => {

  return (
    <div>
      {/* <Section className={classes.pagePaddingTop}> */}
      <HeroSection data={ondcDetails?.banner} />
      {/* </Section> */}

      <VideoSection />

      <Section>
        <TrustedPartner/>
      </Section>
      <SectionAlternate>
        <WhyItMatters data={whyItMatters} />
      </SectionAlternate>
      <Section>
        <WhyMperito data={whyMperito} />
      </Section>

      <SectionAlternate>
        <Process data={ondcOnboarding} />
      </SectionAlternate>

      <Section>
        <FinalSteps data={finalSteps} />
      </Section>
      <SectionAlternate>
        <TransformBusiness data={ondcOnboarding} />
      </SectionAlternate>
      <Section>
        <Benefits data={ondcBenefits} />
      </Section>
      <SectionAlternate>
        <ReadyToStart />
      </SectionAlternate>
    </div>
  );
};

export default ONDC;
